<template>
	<v-container fluid class="mt-4 ml-2">

	  <v-row>
	  	<v-col cols="12">
	  		<div>Reporte de caja por día</div>
	  	</v-col>
	  </v-row>

	  <div v-if="visible==false">{{getdatosUsuario.nomuser}} -- {{date}}</div>

	  <v-row v-if="visible==true">
	  	<v-col cols="6" sm="4" lg="3">
	      <v-text-field
        	dense
        	hide-details
        	outlined
          v-model="date"
          label="Fecha"
          type="date"
        ></v-text-field>
	    </v-col>

	    <v-col cols="6" sm="6" lg="4">
	    	<v-btn 
	    		color="orange" 
	    		tile
	    		dark 
	    		small
	    		class="mr-2"
	    		@click="consultar()"
	    	>
	    		<v-icon>mdi-refresh</v-icon>
	    	</v-btn>
	    	<v-btn 
	    		color="grey" 
	    		tile
	    		dark 
	    		small
	    		@click="imprimir()"
	    	>
	    		<v-icon>mdi-printer</v-icon>
	    	</v-btn>
	    </v-col>
	  </v-row>

	  <!-- Tipos de movimientos para filtros -->
	  <v-row v-if="visible==true">
	  	<v-col cols="6" sm="4" lg="2" v-for="(movim, i) in tipomovimientos" :key="i">
	  		<v-card :color="movim.color" dark :class="`elevation-${movim.elevation}`" @click="seleccionarTiopoM(i, movim)">
	  			<v-card-text>
	  		  	<v-icon v-text="movim.icon" left></v-icon>{{movim.nommovin}} {{movim.cantidad}}
	  			</v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Movimientos -->
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  			<v-card-title class="text-subtitle-1 px-2 py-2">
	  				Cierre de caja
	  			</v-card-title>

    			<v-data-table
	          :headers="headers"
	          :items="movimientos"
	          hide-default-footer
	          fixed-header
	          :items-per-page="length"
	          dense
	          >

	          <template v-slot:item.opciones = "{ item }" > 
			    		<v-btn color="success" icon @click="verMovim(item)"><v-icon>mdi-eye</v-icon></v-btn>
				    </template>
	        </v-data-table>
        </v-card>
	  	</v-col>
	  </v-row>

	  <!-- corte de caja reporte de dinero -->
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  			<v-card-title class="text-subtitle-1 px-2 py-2">
	  				Cierre de caja
	  			</v-card-title>
    			<v-data-table
	          :headers="headersPago"
	          :items="tipoPagos"
	          hide-default-footer
	          fixed-header
	          :items-per-page="5"
	          dense
	          >
				    <template v-slot:item.tipoPagare = "{ item }" > 
			    		<div v-if="item.tipoPagare==1">Efectivo</div>
			    		<div v-if="item.tipoPagare==2">Cheque</div>
			    		<div v-if="item.tipoPagare==3">Transferencia</div>
			    		<div v-if="item.tipoPagare==4">Tarjeta</div>
				    </template>
	        </v-data-table>
	        <v-row class="pa-0">
	        	<v-col cols="6" class="pa-0">
	        		<div class="ml-4 title" align="left" style="font-size: 14px !important;">Total entradas: ({{tipomovimientos[0].cantidad}}) {{totalEntrada}}</div>
	        	</v-col>
	        	<v-col cols="6" class="pa-0">
	        		<div class="ml-4 title" align="left" style="font-size: 14px !important;">Total salidas : ({{tipomovimientos[1].cantidad}}) {{totalSalida}}</div>
	        	</v-col>
	        </v-row>
	        <v-row class="pa-0">
	        	<v-col cols="6" class="pa-0">
	        		<div class="ml-4 title" align="left" style="font-size: 14px !important;">Total: {{totalDia}}</div>
	        	</v-col>
	        	<v-col cols="6" class="pa-0">
	        		<div class="ml-4 title" align="left" style="font-size: 14px !important;">Saldo en caja: {{saldoCaja}}</h2></div>
	        	</v-col>
	        </v-row>
        </v-card>
	  	</v-col>
	  </v-row>

	  <!-- Grafica -->
	  <v-row v-if="visible==true">
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  			<div id="chartdiv" ref="chartdiv"></div>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Ver movimiento -->
	  <v-row justify="center" v-if="dialogMovim">
      <v-dialog v-model="dialogMovim" persistent max-width="350px" >
        <v-card>
          <v-card-title class="text-subtitle-1">Ver movimiento
          	<v-spacer></v-spacer>
          	<v-btn color="red" icon @click="dialogMovim=false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
          	<v-text-field
          	  outlined
          	  label="Folio"
          	  v-model="movim.folio"
          	  dense
          	></v-text-field>

          	<v-text-field
          	  outlined
          	  label="Tipo de pago"
          	  v-model="mtipopago"
          	  dense
          	></v-text-field>
          	<v-text-field
          		type="number"
          	  outlined
          	  label="Total a pagar"
          	  v-model="movim.cantidad"
          	  dense
          	></v-text-field>
          	<v-text-field
          		type="number"
          	  outlined
          	  label="Pago recibído"
          	  v-model="movim.pago"
          	  dense
          	></v-text-field>
          	<v-text-field
          		type="number"
          	  outlined
          	  label="Cambio"
          	  v-model="movim.cambio"
          	  dense
          	></v-text-field>
          	<v-textarea v-model="movim.concepto"  label="concepto" dense outlined></v-textarea>

      			<v-divider></v-divider v-if="movim.tipo != 1 && movim.tipo != 2">

          	<v-text-field
          		v-if="movim.tipo != 1 && movim.tipo != 2"
          	  outlined
          	  label="Autorizó"
          	  v-model="movim.nomuser"
          	  dense
          	  rows="3"
          	  aouto-grow
          	></v-text-field>

          	<v-textarea 
          		v-if="movim.tipo != 1 && movim.tipo != 2"
          		v-model="movim.concepto2" 
          		label="Concepto por cancelación" 
          		dense 
          		outlined
          		rows="3"
          		aouto-grow
          	></v-textarea>
        		<div>
        			Fecha: {{date}}   Hora: {{movim.hora}}
        		</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
            	color="green" 
            	tile
            	small
            	dark 
            	@click="dialogMovim = false"
            >
          		Aceptar
          	</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>

<script>
	import {mapGetters, mapActions} from 'vuex'

	// import * as am4core from "@amcharts/amcharts4/core";
	// import * as am4charts from "@amcharts/amcharts4/charts";
	// import am4themes_animated from "@amcharts/amcharts4/themes/animated";
	// am4core.useTheme(am4themes_animated);
	// var numeral = require('numeral');

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

	export default{

		components:{
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

			visible: true,
			totalEntrada:0,
			totalSalida:0,
			totalDia:0,

			saldoCaja:0,
			total:0,
			// Movimiento
			dialogMovim: false,
			movim:{},
			mtipopago:'',


		 	usuarios:[],
			usuario:{nomuser:'', id:''},

			date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,


      tipomovimientos: [
      	{nommovin:'Entradas',      icon:'mdi-import',         valor:"Entrada"       ,cantidad:0, elevation: 2, color: 'green'},
      	{nommovin:'Salidas',       icon:'mdi-undo',           valor:"Salida"        ,cantidad:0, elevation: 2, color: 'red'},
      	{nommovin:'Cancelaciones', icon:'mdi-close',          valor:"Cancelaciones" ,cantidad:0, elevation: 2, color: 'orange'},
      	{nommovin:'Devoluciones',  icon:'mdi-backup-restore', valor:"Devoluciones"  ,cantidad:0, elevation: 2, color: 'blue'},
      	{nommovin:'Todos',         icon:'mdi-backup-restore', valor:5               ,cantidad:0, elevation: 12, color: 'grey'},
      ],


      headersPago:[
        {text: 'Movimiento', value:'tipoPagare'},
        {text: 'Real', value:'real'},
        {text: 'Reportado', value:'reportado'},
        {text: 'Diferencia', value:'diferencia'},
      ],

     	tipoPagos:[
     		{tipo: 1, real: 0, reportado:0, diferencia: 0},
     		{tipo: 2, real: 0, reportado:0, diferencia: 0},
     		{tipo: 3, real: 0, reportado:0, diferencia: 0},
     		{tipo: 4, real: 0, reportado:0, diferencia: 0},
     	],
			length: 5,
			length2: 5,
			altura: 1000,


			headers:[
        {text: 'id', value:'idmovim'},
        {text: 'Estatus', value:'tipo'},
        {text: 'Folio', value:'folio'},
        {text: 'Concepto', value:'concepto'},
        {text: 'Total', value:'cantidad'},
        {text: 'Pago', value:'pago'},
        {text: 'Cambio', value:'cambio'},
        {text: 'Autorizó', value:'nomuser'},
        {text: 'Tipo de pago', value:'tipopago'},
        {text: 'Hora', value:'hora'},
        {text: 'Opciones', value:'opciones'},
      ],

      movimientos:[],
      movimientostemp:[],

      snackbar: false,
      color:'success',
      text:'',

      idcaja:0,

      dataGrafica:[]
		}),

		created(){
			this.initialize()
		},
		
		mounted() {
	    this.graficar()
	  },

	  beforeDestroy() {
	    if (this.chart) {
	      this.chart.dispose();
	    }
	  },

		methods:{
			...mapActions('login',['ocultarToolbar']),

			imprimir(){
				var temp = this.tipoPagos
				this.tipoPagos = [temp[0]]
				this.visible = false
				this.headers = [
	        {text: 'id', value:'idmovim'},
	        {text: 'Estatus', value:'tipo'},
	        {text: 'Folio', value:'folio'},
	        {text: 'Concepto', value:'concepto'},
	        {text: 'Total', value:'cantidad'},
	        {text: 'Tipo de pago', value:'tipopago'},
	      ]
				this.ocultarToolbar(false)
				setTimeout(()=>{ window.print(); }, 1000);
				
				setTimeout(()=>{ 
					this.ocultarToolbar(true), this.initialize() ,this.visible = true,this.tipoPagos= temp
					this.headers =[
		        {text: 'id'          , value:'idmovim' },
		        {text: 'Estatus'     , value:'tipo'    },
		        {text: 'Folio'       , value:'folio'   },
		        {text: 'Concepto'    , value:'concepto'},
		        {text: 'Total'       , value:'cantidad'},
		        {text: 'Pago'        , value:'pago'    },
		        {text: 'Cambio'      , value:'cambio'  },
		        {text: 'Autorizó'    , value:'nomuser' },
		        {text: 'Tipo de pago', value:'tipopago'},
		        {text: 'Hora'        , value:'hora'    },
		        {text: 'Opciones'    , value:'opciones'},
		      ]

				}, 3000);
			},

			initialize(){
				this.getUsuarios()
			},

			getUsuarios(){
				this.$http.get('user_caja').then(response=>{
					this.usuarios = response.body
				}).catch(error=>{
					this.capturadeError(error.body.message)
				})
			},

			seleccionarTiopoM(posicion, valor){

				console.log( valor)

				this.movimientos = []
				for(const i in this.tipomovimientos){
					if(this.tipomovimientos[i].valor == valor.valor){
						this.tipomovimientos[i].elevation = 16
					}else{
						this.tipomovimientos[i].elevation = 2
					}
				}

				for(const i in this.movimientostemp){
					if(valor.valor == 5){
						this.movimientos = this.movimientostemp
					}else{
						console.log( this.movimientostemp)
						this.movimientos = this.movimientostemp.filter( el => el.tipo == valor.valor )
					}
				}
			},

			consultar(){
				this.totalEntrada = 0
				this.totalSalida = 0
				this.totalDia = 0

				this.total = 0
				this.saldoCaja = 0
				this.tipoPagos = [
	     		{tipoPagare: 1, real: 0, reportado:0, diferencia: 0},
	     		{tipoPagare: 2, real: 0, reportado:0, diferencia: 0},
	     		{tipoPagare: 3, real: 0, reportado:0, diferencia: 0},
	     		{tipoPagare: 4, real: 0, reportado:0, diferencia: 0},
     		]
				this.movimientos = []
				this.tipomovimientos[0].cantidad = 0
				this.tipomovimientos[1].cantidad = 0
				this.tipomovimientos[2].cantidad = 0
				this.tipomovimientos[3].cantidad = 0
				this.tipomovimientos[4].cantidad = 0
				var payload = {
					fecha: this.date
				}

				this.$http.post('cierre_detalle_fecha', payload).then(response=>{
					console.log(response.body)
					// this.tipoPagos = response.body
					for(const i in response.body){
						if(response.body[i].tipo == 1){
							this.tipoPagos[0].real += response.body[i].real
							this.tipoPagos[0].reportado += response.body[i].reportado
							this.tipoPagos[0].diferencia += response.body[i].diferencia
						}
						if(response.body[i].tipo == 2){
							this.tipoPagos[1].real += response.body[i].real
							this.tipoPagos[1].reportado += response.body[i].reportado
							this.tipoPagos[1].diferencia += response.body[i].diferencia
						}
						if(response.body[i].tipo == 3){
							this.tipoPagos[2].real += response.body[i].real
							this.tipoPagos[2].reportado += response.body[i].reportado
							this.tipoPagos[2].diferencia += response.body[i].diferencia
						}
						if(response.body[i].tipo == 4){
							this.tipoPagos[3].real += response.body[i].real
							this.tipoPagos[3].reportado += response.body[i].reportado
							this.tipoPagos[3].diferencia += response.body[i].diferencia
						}

					}

					this.$http.post('movimientos.fecha',payload).then(response=>{
						var salida = 0
						var id = 0

						this.movimientostemp = response.body
						this.movimientos = response.body
						for(const i in this.movimientos){
							id += 1
							this.movimientos[i].idmovim = id
							if(this.movimientos[i].tipo == 1){
								this.movimientos[i].tipo = 'Entrada'

								this.tipomovimientos[0].cantidad += 1
								this.totalEntrada += this.movimientos[i].cantidad
							}
							if(this.movimientos[i].tipo == 2){
								this.movimientos[i].tipo = 'Salida'
								this.tipomovimientos[1].cantidad += 1
								salida += this.movimientos[i].cantidad
								this.totalSalida += this.movimientos[i].cantidad
							}
							if(this.movimientos[i].tipo == 3){
								this.movimientos[i].tipo = 'Cancelación'
								this.tipomovimientos[2].cantidad += 1
							}
							if(this.movimientos[i].tipo == 4){
								this.movimientos[i].tipo = 'Devolución'
								this.tipomovimientos[3].cantidad += 1
							}

							if(this.movimientos[i].tipopago == 1 ){
								this.movimientos[i].tipopago = 'Efectivo'
							}

							if(this.movimientos[i].tipopago == 2 ){
								this.movimientos[i].tipopago = 'Cheque'
							}

							if(this.movimientos[i].tipopago == 3 ){
								this.movimientos[i].tipopago = 'Transferencia'
							}

							if(this.movimientos[i].tipopago == 4 ){
								this.movimientos[i].tipopago = 'Tarjeta'
							}

							this.tipomovimientos[4].cantidad += 1
						}

						var efectivo = 0
						var cheque = 0
						var transferencia = 0
						var tarjeta = 0

						for(const i in this.movimientostemp){
							if(this.movimientostemp[i].tipo == 1){
								if(this.movimientostemp[i].tipopago == 1){
									efectivo += this.movimientostemp[i].cantidad
								}
								if(this.movimientostemp[i].tipopago == 2){
									cheque += this.movimientostemp[i].cantidad
								}
								if(this.movimientostemp[i].tipopago == 3){
									transferencia += this.movimientostemp[i].cantidad
								}
								if(this.movimientostemp[i].tipopago == 4){
									tarjeta += this.movimientostemp[i].cantidad
								}
							}
						}



						this.altura = ( response.body.length * 37 ) + 32
						this.length = response.body.length

						this.dataGrafica = [
							{tipodePago: 'Efectivo', cantidad: efectivo},
							{tipodePago: 'Cheque', cantidad: cheque},
							{tipodePago: 'Transferencia', cantidad: transferencia},
							{tipodePago: 'Tarjeta', cantidad: tarjeta},
						]
						this.total = efectivo + cheque + transferencia + tarjeta
						this.total = numeral(this.total).format('0,0.00')

						this.totalDia = this.totalEntrada - this.totalSalida
						this.totalDia = numeral(this.totalDia).format('0,0.00');

						this.totalEntrada = numeral(this.totalEntrada).format('0,0.00');
						this.totalSalida = numeral(this.totalSalida).format('0,0.00');

						var fecha = {fecha: this.date}
						this.$http.post('saldoinicial', fecha).then(response=>{
							console.log(response.body)
							this.saldoCaja = response.body.saldoinicial  + this.tipoPagos[0].reportado - salida
							this.saldoCaja = numeral(this.saldoCaja).format('0,0.00');
							this.graficar()
							this.formatos()

						}).catch(error=>{
							this.capturadeError(error.body.message)
						})

					}).catch(error=>{
						this.capturadeError(error.body.message)
					})
				}).catch(error=>{
					this.capturadeError(error.body.message)
				})
			},

			formatos(){
				for(const i in this.movimientostemp){
					this.movimientostemp[i].cantidad = numeral(this.movimientostemp[i].cantidad).format('0,0.00');
					this.movimientostemp[i].cambio = numeral(this.movimientostemp[i].cambio).format('0,0.00');
					this.movimientostemp[i].pago = numeral(this.movimientostemp[i].pago).format('0,0.00');
				}

				for(const i in this.tipoPagos){
					this.tipoPagos[i].real = numeral(this.tipoPagos[i].real).format('0,0.00');
					this.tipoPagos[i].reportado = numeral(this.tipoPagos[i].reportado).format('0,0.00');
					this.tipoPagos[i].diferencia = numeral(this.tipoPagos[i].diferencia).format('0,0.00');
				}
			},

			capturadeError(value){
        this.color = 'error'
        this.text = value
        this.snackbar = true
      },

      graficar(){
      	let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

		    chart.paddingRight = 20;

		    let data = this.dataGrafica
		    

		    chart.data = data;

		    chart.padding(40, 40, 40, 40);

				var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
				categoryAxis.renderer.grid.template.location = 0;
				categoryAxis.dataFields.category = "tipodePago";
				categoryAxis.renderer.minGridDistance = 60;
				categoryAxis.renderer.inversed = true;
				categoryAxis.renderer.grid.template.disabled = true;

				var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
				valueAxis.min = 0;
				valueAxis.extraMax = 0.1;
				//valueAxis.rangeChangeEasing = am4core.ease.linear;
				//valueAxis.rangeChangeDuration = 1500;

				var series = chart.series.push(new am4charts.ColumnSeries());
				series.dataFields.categoryX = "tipodePago";
				series.dataFields.valueY = "cantidad";
				series.tooltipText = "{valueY.value}"
				series.columns.template.strokeOpacity = 0;
				series.columns.template.column.cornerRadiusTopRight = 10;
				series.columns.template.column.cornerRadiusTopLeft = 10;
				//series.interpolationDuration = 1500;
				//series.interpolationEasing = am4core.ease.linear;
				var labelBullet = series.bullets.push(new am4charts.LabelBullet());
				labelBullet.label.verticalCenter = "bottom";
				labelBullet.label.dy = -10;
				labelBullet.label.text = "{values.valueY.workingValue.formatNumber('#.')}";

				chart.zoomOutButton.disabled = true;

				// as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
				series.columns.template.adapter.add("fill", function (fill, target) {
				 return chart.colors.getIndex(target.dataItem.index);
				});


				categoryAxis.sortBySeries = series;

		    this.chart = chart;
      },

      verMovim(value){
      	if(value.tipopago == 1){
      		this.mtipopago = 'Efectivo'
      	}
      	if(value.tipopago == 2){
      		this.mtipopago = 'Cheque'
      	}
      	if(value.tipopago == 3){
      		this.mtipopago = 'Transferencia'
      	}
      	if(value.tipopago == 4){
      		this.mtipopago = 'Tarjeta'
      	}
      	this.movim = value
      	this.dialogMovim = true
      }
		},

		computed:{
			...mapGetters('login',['getdatosUsuario'])
		}
	}
</script>

<style scoped>
	#chartdiv {
	  width: 100%;
	  height: 500px;
	}

</style>